import React from 'react';

import './index.scss';
import Root from './routes/root';
import Providers from './Providers';
import './i18n';

const App = () => {
  return (
    <Providers>
      <Root />
    </Providers>
  );
};
export default App;
